import dlv from 'dlv';
import * as React from 'react';
import Cta from '../Cta';
import Galleries from '../Galleries';
import { markdownShortcodeMap } from '../Markdown';
import YoutubeVideo from '../Markdown/YoutubeVideo';
import RawTable from '../Table';
export const EntityContext = React.createContext(undefined);
function EntityTable({ path = 'table', width, }) {
    if (!path) {
        return null;
    }
    return (React.createElement(EntityContext.Consumer, null, entity => {
        if (!entity) {
            return null;
        }
        const { headers, data } = dlv(entity, path, {});
        if (!headers || !data) {
            return null;
        }
        return (React.createElement("div", { className: "overflow-x-scroll" },
            React.createElement(RawTable, { width: width, headers: headers, data: data })));
    }));
}
function EntityGalleries({ path = 'galleries', display, }) {
    return (React.createElement(EntityContext.Consumer, null, entity => {
        if (!entity) {
            return null;
        }
        const images = dlv(entity, path);
        if (!images) {
            return null;
        }
        return (React.createElement(Galleries, { images: images, displayItems: display ? parseInt(display, 10) : undefined }));
    }));
}
function EntityVideos({ path = 'videos' }) {
    return (React.createElement(EntityContext.Consumer, null, entity => {
        if (!entity) {
            return null;
        }
        const videos = dlv(entity, path);
        return (React.createElement("div", null, videos.map(id => (React.createElement(YoutubeVideo, { id: id, key: id })))));
    }));
}
function EntityCta({ path = 'cta' }) {
    return (React.createElement(EntityContext.Consumer, null, entity => {
        if (!entity) {
            return null;
        }
        const cta = dlv(entity, path);
        return React.createElement(Cta, Object.assign({}, cta));
    }));
}
export const shortcodeMap = {
    ...markdownShortcodeMap,
    cta: EntityCta,
    table: EntityTable,
    galleries: EntityGalleries,
    videos: EntityVideos,
};
export function Shortcode(props) {
    const { identifier, attributes } = props;
    const Component = shortcodeMap[identifier];
    if (!Component) {
        return null;
    }
    return React.createElement(Component, Object.assign({}, attributes));
}
//# sourceMappingURL=Shortcode.js.map